import ContributorSelectorList from './ContributorSelectorList';

export default function ContributorChildrenList({
	selectorListState,
	disabled,
	disableRemove,
	locked,
}) {
	return (
		<ContributorSelectorList
			label='Assign Children'
			textFieldLabel='Child'
			disabled={disabled}
			disableRemove={disableRemove}
			locked={locked}
			{...selectorListState}
		/>
	);
}
